<template>
  <div>
    <h2>{{ $t('title.persons') }}</h2>

    <base-list
      model="persons"
      :columns="['name', 'address', 'workplace']"
      s-model="person"
    />
  </div>
</template>

<script>
import BaseList from 'components/BaseList'

export default {
  name: 'person-list',
  components: { BaseList }
}
</script>



// WEBPACK FOOTER //
// PersonList.vue?73bb128e